export const columns = [
  {
    Header: 'Benchmark',
    accessor: 'col1',
  },
  {
    Header: 'Description',
    accessor: 'col2',
  },
];

export const data = [
  {
    col1: 'Absolute Return',
    col2: 'Annual basis point adjustment on it’s own or in addition to another component'
  },
  {
    col1: 'Asset Weighted ',
    col2: 'Individual assets/investments whose weights dynamically change over time'
  },
  {
    col1: 'Composite Return',
    col2: 'Actual return of an asset or composite'
  },
  {
    col1: 'Composite Weighted',
    col2: 'Various composite components whose weights dynamically change over time'
  },
  {
    col1: 'Pull Forward',
    col2: 'A component where the returns are delayed on certain days, months or quarters'
  },
  {
    col1: 'Static Weighted',
    col2: 'Components with fixed weights as a percentage'
  },
];